var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-broadcast-menu"},[_c('items-menu',{attrs:{"items":_vm.items},on:{"choose":_vm.onItemChoose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }